import React from 'react';
import '../promptimizer/index.css';
import PromptimizerApp from '../promptimizer/App';

const Promptimizer = () => {
  return <PromptimizerApp />;
};

export default Promptimizer;
